import { translateLanguage } from 'components';
import {
  ADDGUARDIANCONTENT,
  PatientCardContent,
  PatientDetailContent,
  PatientListContent,
} from 'models';

export const ALL_PATIENTS_COLUMNS = [
  {
    id: 'Id',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientID]}`,
    )}`,
    isNumeric: true,
  },
  {
    id: 'FullName',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientName]}`,
    )}`,
    hasColumnClick: true,
  },
  {
    id: 'PrimaryPhone1',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientPhone]}`,
    )}`,
    hasEditMode: true,
  },
  {
    id: 'PrimaryEmailAddress',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientEmail]}`,
    )}`,
    hasColumnClick: true,
  },
  {
    id: 'PrimaryCity',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientCity]}`,
    )}`,
  },
  {
    id: 'Tag',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.PatientTag]}`,
    )}`,
    isCenterAlign: true
  },
  {
    id: 'Deleted',
    displayName: `${translateLanguage(
      `Patients.${[PatientListContent.Deleted]}`,
    )}`,
    isNumeric: true,
    dropDownOption: [
      {
        id: `${[PatientListContent.NoDeleted]}`,
        displayName: `${translateLanguage(
          `Patients.${[PatientListContent.NoDeleted]}`,
        )}`,
      },
      {
        id: `${[PatientListContent.YesDeleted]}`,
        displayName: `${translateLanguage(
          `Patients.${[PatientListContent.YesDeleted]}`,
        )}`,
      },
    ],
  },
];

export const Patient = `${translateLanguage(
  `Patients.${[PatientListContent.Patient]}`,
)}`;

export const PatientDuplicateTableTitle = [
  `${translateLanguage(`Patients.${[PatientListContent.PatientName]}`)}`,
  `${translateLanguage(`Patients.${[PatientListContent.PatientID]}`)}`,
  `${translateLanguage(`Patients.${[PatientListContent.PatientPhone]}`)}`,
  `${translateLanguage(`Patients.${[PatientListContent.PatientEmail]}`)}`,
];

export const intialPatientData = {
  id: 0,
  firstName: '',
  lastName: '',
  salutationType: '',
  salutation: '',
  primaryAddressType: '',
  primaryAddress: '',
  primaryCity: '',
  primaryProvince: '',
  stateCode: '',
  countryId: '',
  primaryPostalCode: '',
  primaryCountry: '',
  primaryPhoneType1: '',
  primaryPhone1: '',
  primaryPhoneType2: '',
  primaryPhone2: '',
  primaryPhoneType3: '',
  primaryPhone3: '',
  primaryEmailAddress: '',
  notes: '',
  referralId: 0,
  firstContactDate: new Date(),
  dateofBirth: null,
  noMail: false,
  noEmail: false,
  modifiedTime: new Date(),
  creditcard: '',
  credittype: '',
  expiry: new Date(Date.now()),
  healthCardNumber: '',
  healthCardVersion: '',
  healthCardExpiry: '',
  lastAppointment: 0,
  deleted: false,
  physicianId: 0,
  enteredStaffId: 0,
  sex: '',
  noCallReminders: false,
  mediaClient: false,
  hadMeetAndGreet: 0,
  hadTestSpot: 0,
  hadPrePhotos: 0,
  hadPostPhotos: 0,
  modifiedStaffId: 0,
  bookingNotes: '',
  isBlacklisted: false,
  balanceDue: false,
  locationId: 0,
  mugshot: '',
  heightFt: 0,
  heightIn: 0,
  version: '',
  cid: '',
  casl: false,
  procedureId: 0,
  packageId: '',
  membershipId: '',
  nonpotential: false,
  brandAmbassador: false,
  pointRewards: 0,
  podiumReviews: false,
  tenDtoAppConsent: false,
  forthyeighHtoAppConsent: false,
  twentyfourHtoAppConsent: false,
  twentyfourHafterAppConsent: false,
  sevenDafterAppConsent: false,
  forteenDafterConsent: false,
  virtualConsultsConsent: false,
  secondVirtualConsultsConsent: false,
  callLeadId: '',
  fullName: '',
  leadID: 0,
  monthName: 0,
  referrerPatientID: 0,
  title: '',
  yearName: 0,
  secondaryProcedureID: '',
  secondaryPackageID: '',
  secondaryMembershipID: '',
  [ADDGUARDIANCONTENT.RELATEDPATIENTS]: [],
  [ADDGUARDIANCONTENT.ISMINOR]: false,
  provider1Phone: '',
  provider2Phone: '',
  insuredBirthday: null,
  provider1PlanID: '',
  provider2PlanID: '',
  provider1PolicyID: '',
  provider2PolicyID: '',
  insuredProvider1Name: '',
  insuredProvider2Name: '',
  insuredProvider1Group: '',
  insuredProvider2Group: '',
  relationshipwiththeInsured: '',
  occupation: '',
  salaryRange: '',
  concernsAndGoals: '',
  noText: false,
  noShows: 0,
  insuredName: '',
  tag: ''
};

export const GuardianColumns = [
  {
    id: `${ADDGUARDIANCONTENT.PATIENT}`,
    displayName: translateLanguage(`Patients.${[ADDGUARDIANCONTENT.PATIENT]}`),
  },
  {
    id: `${ADDGUARDIANCONTENT.PHONENO}`,
    displayName: translateLanguage(`Patients.${[ADDGUARDIANCONTENT.PHONENO]}`),
  },
  {
    id: `${ADDGUARDIANCONTENT.EMAIL}`,
    displayName: translateLanguage(`Patients.${[ADDGUARDIANCONTENT.EMAIL]}`),
  },
  {
    id: `${ADDGUARDIANCONTENT.GUARDIAN}`,
    displayName: translateLanguage(`Patients.${[ADDGUARDIANCONTENT.GUARDIAN]}`),
  },
];

export const patientMockData = {
  id: 87882,
  referrerPatientID: 0,
  salutation: 'Mr Masudtest Chowdhury',
  fullName: 'Masudtest Chowdhury',
  primaryAddressType: 'Billing',
  primaryAddress: 'fh',
  primaryCity: 'fh',
  primaryProvince: 'CA',
  primaryPostalCode: '',
  primaryCountry: 'USA',
  primaryPhoneType1: 'Home',
  primaryPhone1: '(111) 111-1111',
  primaryPhoneType2: 'Work',
  primaryPhone2: '',
  primaryPhoneType3: 'Mobile',
  primaryPhone3: '',
  primaryEmailAddress: 'test@test.com',
  notes: '(Marysdfgdsfg-Sun, Sep 11, 2022)updated notes -activity log changes',
  creditcard: '',
  credittype: 'Visa',
  creditCardExpiry: '1/1900',
  monthName: 1,
  yearName: 1900,
  healthCardNumber: '123456789',
  healthCardVersion: '1',
  referralId: 115,
  firstContactDate: 'Mon, Sep 12, 2022',
  dateofBirth: 'Tue, Mar 19, 1957',
  noMail: true,
  noEmail: false,
  lastAppointment: null,
  deleted: false,
  sex: 'Female',
  noCallReminders: false,
  mediaClient: false,
  mugshot: null,
  casl: true,
  nonpotential: false,
  brandAmbassador: false,
  pointRewards: null,
  podiumReviews: false,
  tenDtoAppConsent: false,
  forthyeighHtoAppConsent: false,
  twentyfourHtoAppConsent: false,
  twentyfourHafterAppConsent: false,
  sevenDafterAppConsent: false,
  forteenDafterConsent: false,
  virtualConsultsConsent: false,
  secondVirtualConsultsConsent: false,
  callLeadId: null,
  leadID: 0,
  title: null,
  procedure: 'Single Tx - Hair Club Medium Zone',
  googleMapItems: [
    {
      title: 'Get map directions to:',
      gMapUrl: '',
    },
    {
      title: 'All location',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=updated address+Toronto+ON+fdh+Canada&daddr=fh+fh+CA++USA',
    },
    {
      title: 'Toronto',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=fh+Toronto+Ontario+fdgh+Canada&daddr=fh+fh+CA++USA',
    },
    {
      title: 'ghk',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=+Toronto+Ontario+dfgh+Canada&daddr=fh+fh+CA++USA',
    },
    {
      title: 'title56',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=hyd++abc++India&daddr=fh+fh+CA++USA',
    },
    {
      title: 'title90',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=hyd++abc++India&daddr=fh+fh+CA++USA',
    },
    {
      title: 'string',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=string+string+string+string+string&daddr=fh+fh+CA++USA',
    },
    {
      title: 'Colarado',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=ffrf+ffrffdgds+dgsdfg+fgfgefag+fdfdfa&daddr=fh+fh+CA++USA',
    },
    {
      title: 'Test2',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=ffrf+ffrffdgds+dgsdfg+fgfgefag+fdfdfa&daddr=fh+fh+CA++USA',
    },
    {
      title: 'Test3',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=ffrf+ffrffdgds+dgsdfg+fgfgefag+fdfdfa&daddr=fh+fh+CA++USA',
    },
    {
      title: 'IVC',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=updateAddress+Toronto+ON+243413+USA&daddr=fh+fh+CA++USA',
    },
    {
      title: 'NEWTEST',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'pune',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=pune+pune+MH+441001+IND&daddr=fh+fh+CA++USA',
    },
    {
      title: 'GOA',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=GOA+GOA+GOA+12121+IND&daddr=fh+fh+CA++USA',
    },
    {
      title: 'PUNEE',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=PUNEE++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'nagar',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=nagar++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'Nashik',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=Nashik++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'rr123',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=Peth Road+Pune+Maharashtra++India&daddr=fh+fh+CA++USA',
    },
    {
      title: 'asdasda',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=dfgh+Toronto+Ontario+dfh+Canada&daddr=fh+fh+CA++USA',
    },
    {
      title: 'addtime',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'assssss',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'aaawwww',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'asasas',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'pratik',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'nilesh',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'mocktime',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'addnotestime',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'jadhav',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'timeZone',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'llllkkkk',
      gMapUrl:
        'http://maps.google.com/maps?f=d&saddr=pune++++&daddr=fh+fh+CA++USA',
    },
    {
      title: 'add',
      gMapUrl: 'http://maps.google.com/maps?f=d&saddr=++++&daddr=fh+fh+CA++USA',
    },
  ],
  address: 'fh<br />fh, CA, USA<br />',
  creditCardDesc: 'Type: Visa<br />#: <br />Expiry: 1/1900',
  locationDr: 'All location (Dr. Marysdfgdsfg sdfgsdfg)',
  staffName: 'Marysdfgdsfg sdfgsdfg',
  healthCard: '#: 123456789<br />Ver.:1',
  contact: null,
  referralTitle: 'Arlene Bynon',
  canModifyNurtureSeries: false,
  canVoidReceipt: true,
  canVoidCreditMemo: true,
  firstName: 'Masudtest',
  lastName: 'Chowdhury',
  salutationType: 'Mr',
  modifiedTime: '12/09/2022',
  physicianId: 1563,
  enteredStaffId: 1563,
  hadMeetAndGreet: 0,
  hadTestSpot: 0,
  hadPrePhotos: 0,
  hadPostPhotos: 0,
  modifiedStaffId: 1563,
  bookingNotes: null,
  isBlacklisted: false,
  balanceDue: false,
  locationId: 1,
  heightFt: 0,
  heightIn: 0,
  procedureId: 188,
  secondaryProcedureID: '',
  secondaryProcedures: '',
  lastAppointmentDate: null,
  nextAppointmentDate: null,
  lastAppointmentProcedure: 'NONE',
  nextAppointmentProcedure: 'NONE',
  insured: true,
  insuredProvider1Name: 'ABC Insurer',
  insuredProvider2Name: 'XYZ Insurer',
  insuredProvider1Group: 'ABC Group',
  insuredProvider2Group: 'XYZ Group',
  provider1Phone: '1111111111',
  provider2Phone: '2222222222',
  insuredName: 'test',
  insuredBirthday: '2010-01-06 08:00:00.000',
  relationshipwiththeInsured: 'Friend',
  provider1PolicyID: '12esda12',
  provider2PolicyID: '123adfafa',
  provider1PlanID: 'plan1',
  provider2PlanID: 'plan2',
  healthCardExpiry: '2024-01-06T08:00:00',
  isMinor: true,
  occupation: 'Physician',
  salaryRange: '10000-10000000',
  concernsAndGoals: 'test goals',
  noText: false,
  noShows: 0,
  lifeTimeValue: 0,
  relatedPatients: [
    {
      relatedPatientId: 87718,
      isGaurdian: true,
      relatedPatientPrimaryPhone: '9000228159',
      relatedPatientFullName: 'Masud Chowdhury',
    },
    {
      relatedPatientId: 87780,
      isGaurdian: true,
      relatedPatientPrimaryPhone: '(565) 756-7666',
      relatedPatientFullName: 'akash deep',
    },
  ],
};

export const CARD_DETAILS_TABLE_COLUMNS = [
  { title: translateLanguage(`Patients.${PatientCardContent.CARDTYPE}`) },
  { title: translateLanguage(`Patients.${PatientCardContent.CARDNUMBER}`) },
  { title: translateLanguage(`Patients.${PatientCardContent.EXPIRY}`) },
  { title: '' },
];


export const patientNotesColumns = [
  {
    id: `${PatientDetailContent.AUTHOER}`,
    displayName: `${translateLanguage(
      `PatientDetails.${[PatientDetailContent.AUTHOER]}`,
    )}`,
    // width: 150,
  },
  {
    id: `${PatientDetailContent.CREATEDDATE}`,
    displayName: `${translateLanguage(
      `PatientDetails.${[PatientDetailContent.CREATEDDATE]}`,
    )}`,
    isCalender: true,
    isNumeric: true,
    searchDate: true,
    formatDateDMY: true,
    width: 170,
  },
  {
    id: `${PatientDetailContent.Note}`,
    displayName: `${translateLanguage(
      `PatientDetails.${[PatientDetailContent.Notes]}`,
    )}`,
  },
  {
    id: 'Actions',
    displayName: ` `,
    noSort: true,
    noSearch: true,
    isRightAlign: true,
  },
];